import destroy from './destroy';
import edit from './edit';
import preview from './preview';

export default {
  edit,
  preview,
  destroy,
};
